import React, { FC, memo } from 'react';
import DropdownWithChildren from '@minecraft.dropdown-with-children';
import { useDrawerSearchFilterNameOrCategory } from '@minecraft.drawer';
import { FilterData } from '../../../shared/types';
import { Label } from '../../../shared/styles';
import { FiltersCategoryNameEnum } from '../../shared/types';

type Props = FilterData;

const DogBreed: FC<Props> = ({ name, label }) => {
  const { getMatchedSearchOptions } = useDrawerSearchFilterNameOrCategory(FiltersCategoryNameEnum.assets);

  return (
    <>
      <Label>{label}</Label>
      <DropdownWithChildren
        withFormik
        withSelectionsResult
        isFullWidth
        name={name}
        options={getMatchedSearchOptions(name)}
      />
    </>
  );
};

export default memo(DogBreed);
